import React, { useState } from 'react'
import GoogleMapReact from 'google-map-react'

// Small "where is this course" card: a location map with a marker, a reverse-geocoded address
// (like the Android app), an optional free-text directions note, and a Directions button that
// opens Google Maps. `location` is in decimal degrees ({ lat, lng }) or null.
export default function CourseLocationCard({
  location = null,
  locationLabel = '',
  directions = '',
}) {
  const [address, setAddress] = useState(null)

  const onGoogleApiLoaded = (map) => {
    new window.google.maps.Marker({ position: location, map })

    // Reverse geocode to a human-readable address, mirroring how Android shows getAddressLine(0).
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({ location }, (results, status) => {
      if (status === 'OK' && results && results[0]) {
        setAddress(results[0].formatted_address)
      }
    })
  }

  const directionsUrl = location
    ? `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`
    : null

  return (
    <div className="course-location">
      {location && (
        <div className="course-location--map">
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_MAPS_KEY }}
            defaultCenter={location}
            defaultZoom={13}
            yesIWantToUseGoogleMapApiInternals={true}
            onGoogleApiLoaded={({ map }) => onGoogleApiLoaded(map)}
            options={{
              fullscreenControl: false,
              zoomControl: true,
              gestureHandling: 'cooperative',
            }}
          />
        </div>
      )}
      <div className="course-location--info">
        <div className="course-location--address">
          <i className="bi bi-geo-alt-fill" />
          <span>{address || locationLabel || 'Location unavailable'}</span>
        </div>
        {directions && <p className="course-location--directions">{directions}</p>}
        {directionsUrl && (
          <a
            className="btn btn-primary course-location--button"
            href={directionsUrl}
            rel="noreferrer"
            target="_blank"
          >
            <i className="bi bi-signpost-2-fill" /> Directions
          </a>
        )}
      </div>
    </div>
  )
}
